export default __webpack_public_path__ + "static/media/instagram.b243afd7.svg";